import { Model } from '@vuex-orm/core';
import Address from './Address';
import DeliveryPeriod from './DeliveryPeriod';
import Position from './Position';
import Material from './Material';
import { PaymentModes } from '@/utils/constants';

export default class Transaction extends Model {
    static entity = 'transactions';

    static fields() {
        return {
            id: this.increment(),

            priceResponseId: this.string(null).nullable(),
            offerId: this.string(null).nullable(),
            campaignParticipantId: this.string(null).nullable(),

            auftraggeber_id: this.number(null).nullable(),
            discountCode: this.string(null).nullable(),
            myClimate: this.boolean(false),
            deliveryPeriod_id: this.number(null).nullable(),
            material_id: this.number(null).nullable(),
            priceResponse_id: this.string(null).nullable(),
            paymentMode: this.string(PaymentModes.SingleUP).nullable(),
            differentPaymentConfigurationText: this.string(null).nullable(),
            wantsNewsletter: this.boolean(false),
            dseAccepted: this.boolean(false),
            agbAccepted: this.boolean(false),

            //relations
            auftraggeber: this.belongsTo(Address, 'auftraggeber_id'),
            deliveryPeriod: this.belongsTo(DeliveryPeriod, 'deliveryPeriod_id'),
            positions: this.hasMany(Position, 'transaction_id'),
            material: this.belongsTo(Material, 'material_id')
        }
    }

    get isCampaignOffer() {
        return this.campaignParticipantId !== null;
    }

    get totalAmount() {
        return this.positions.reduce(function (total, pos) { return total + pos.amount; }, 0);
    }

    //make sure, that you eager-loaded the positions and their warenempfaenger when you call this method!
    arePriceRelevantPropertiesSet(product) {
        //material isn't checked here because it does not need to be set for a price request
        if (this.deliveryPeriod_id === null || this.positions === null || this.positions.length === 0) {
            return false;
        }

        //so far so good, now check the positions
        for (let i = 0; i < this.positions.length; i++) {
            let pos = this.positions[i];

            //check if the position has a warenempfaenger
            if (pos.warenempfaenger_id === null || pos.warenempfaenger === null) {
                return false;
            }

            //product dependent checks
            switch (product) {
                case 'Heizoel':
                case 'Diesel':
                case 'Pellets':
                    if (pos.amount < this.$store().state.MinAmountPerUP) {
                        return false;
                    }
                    if (this.isCampaignOffer && pos.amount > this.$store().state.MaxAmountTotal) {
                        return false;
                    }
                    break;
            }

            let we = pos.warenempfaenger;
            if (
                !we.isServerAddress //if it's a serverAddress, we're happy
                && (we.zipcode == null
                    || we.zipcode < 1000
                    || we.zipcode > 9999
                    || we.city === null
                    || we.city === ''
                )
            ) {
                return false;
            }
        }

        //all positions are good
        return true;
    }

    //make sure, that you eager-loaded the positions and their warenempfaenger when you call this method!
    priceRelevantPropertiesWatcher() {
        //get json for transaction
        let arr = [this.myClimate, this.deliveryPeriod_id, this.discountCode];

        //append json for all positions
        for (let i = 0; i < this.positions.length; i++) {
            let pos = this.positions[i];
            arr.push(pos.amount);

            let we = pos.warenempfaenger;
            if (we != null) {
                arr.push(we.id);
                arr.push(we.isServerAddress);
                arr.push(we.zipcode);
                arr.push(we.city);
            }
        }

        return JSON.stringify(arr);
    }
}